import React from 'react'
import { FormattedMessage } from 'react-intl'

import { TtButton, TtPoll, TtPollAnswer } from '@23/react'

import { type Poll } from '../../../models/poll'
import { useStartPollMutation } from '../../../hooks/use-polls'

interface CreatedPollProps {
  poll: Poll
}

const CreatedPoll = ({ poll }: CreatedPollProps) => {
  const { mutateAsync: startPoll, isLoading } = useStartPollMutation(poll.id)

  return (
    <>
      <TtPoll label={poll.question}>
        {poll.options.map((option) => (
          <TtPollAnswer key={option.id} label={option.option} value={0} />
        ))}
      </TtPoll>
      <TtButton
        color="secondary"
        size="small"
        pill
        onClick={() => startPoll()}
        loading={isLoading}
        disabled={isLoading}
      >
        <FormattedMessage defaultMessage="Start Poll" />
      </TtButton>
    </>
  )
}

export { CreatedPoll }
